import React, { useEffect, useRef, forwardRef } from 'react';
import { useHistory } from "react-router-dom";
import { useGlobal } from 'reactn';
import { useTranslation } from 'react-i18next';
import Selectivity from 'selectivity/react';
import { default as ReactSelect, components } from "react-select";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { addDays } from "date-fns";
import de from 'date-fns/locale/de';

import { useApi } from 'stores/api';
import RangeInputs from './RangeInputs';

import 'selectivity/styles/selectivity.css';
import "react-datepicker/dist/react-datepicker.css";
import 'components/SearchBar.css';


const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

// const MultiValueContainer = (props) => {
//     console.log(props);
//     return (
//         <>
//             <div className='label'>{props.selectProps.placeholder}</div>
//             <components.MultiValueContainer {...props} />
//         </>
//     );
// };

// const SelectContainer = ({ children, ...props }) => {
//     return (
//         <div className={'customise your select container'}>
//             <components.SelectContainer {...props}>
//                 {props.selectProps.placeholder} {children}
//             </components.SelectContainer>
//         </div>
//     );
// };

const ValueContainer = ({ children, ...props }) => (
    <>
        <div className='label'>{props.selectProps.placeholder}</div>
        <components.ValueContainer {...props}>{children}</components.ValueContainer>
    </>
);

const Placeholder = (props) => {
    return <></>;
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <i className="fa fa-caret-down" aria-hidden="true"></i>
        </components.DropdownIndicator>
    );
};

const SearchBar = (props) => {
    registerLocale('de', de);
    setDefaultLocale('de');
    const { t } = useTranslation(['searchbar']);
    const history = useHistory();
    const api = useApi();

    const [masterData] = useGlobal('masterData');
    const [showLoader, setShowLoader] = useGlobal('showLoader');
    const [searchParams, setSearchParams] = useGlobal('searchParams');
    const [searchPageVars, setSearchPageVars] = useGlobal('searchPageVars');
    const [markerLoc, setMarkerLoc] = useGlobal('markerLoc');
    const [markerLatLng, setMarkerLatLng] = useGlobal('markerLatLng');
    const [markerVars] = useGlobal('markerVars');
    const [searchNow, setSearchNow] = useGlobal('searchNow');
    const [cartCount] = useGlobal('cartCount');
    const [isDirty, setIsDirty] = useGlobal('isDirty');
    const [isSameTimePeriod] = useGlobal('isSameTimePeriod');
    const maxAhead = masterData.organization.MaxBookingAhead || 365;
    
    const [openFilters, setOpenFilters] = useGlobal('openFilters');
    const [openSlider, setOpenSlider] = useGlobal('openSlider');
    const onInputChange = (
        inputValue,
        { action, prevInputValue }
    ) => {
        if (action === 'input-change') return inputValue;
        if (action === 'menu-close') {
            if (prevInputValue) { }
        }
        return prevInputValue;
    };
    const [optionsSelected, setOptionsSelected] = useGlobal('optionsSelected');
    const onChangeMultiSelect = (refRentalParameterId, selected) => {
        if (!selected.length) {
            const clone = optionsSelected;
            delete clone[refRentalParameterId];
            setOptionsSelected({ ...clone });
        } else {
            setOptionsSelected({
                ...optionsSelected, [refRentalParameterId]: [...selected]
            });
        }
    };
    const [rangeFilters, setRangeFilters] = useGlobal('rangeFilters');

    const refLocation = useRef();
    const refCategory = useRef();

    const updateSearchPageVars = (prop, value) => {
        setSearchPageVars({ ...searchPageVars, [prop]: value });
    }

    const CustomInputStart = forwardRef(({ value, onClick }, ref) => (
        <div onClick={onClick} ref={ref} className="custom-input-date start">
            <div className="label small">{t("startdate")}</div>
            <div className="custom-input-selectedValue">{value}</div>
        </div>
    ));

    const CustomInputEnd = forwardRef(({ value, onClick }, ref) => (
        <div onClick={onClick} ref={ref} className="custom-input-date end">
            <div className="label small">{t("enddate")}</div>
            <div className="custom-input-selectedValue">{value}</div>
        </div>
    ));

    const getSearchContainerClass = () => {
        const searchFieldsCount = 2 + (searchPageVars.showLocation ? 1 : 0) + (searchPageVars.showCategory ? 1 : 0);
        let searchClass = '';
        switch (searchFieldsCount) {
            case 2:
                searchClass = ' two';
                break;
            case 3:
                searchClass = ' three';
                break;
            case 4:
                searchClass = ' four';
                break;
        }
        return searchClass;
    }

    const onLocationChanged = async (newVal, isMarkerClick) => {
        let businessUnitId = newVal;
        let { rentalCategoryId, rentalSubcategoryId } = searchParams;
        let showCategory = searchPageVars.showCategory;
        let showLocation = searchPageVars.showLocation;
        let subcat = searchPageVars.currentSubcat;

        let facetsUpdated = false;
        let objFacets = {};
        let objFeatureEnums = [];
        let objFeatureRanges = [];

        if (newVal) {
            if (searchPageVars.categories[newVal] && searchPageVars.categories[newVal].length === 1 &&
                searchPageVars.categories[newVal][0].children.length === 1) {
                showCategory = false;
                rentalCategoryId = searchPageVars.categories[newVal][0].categoryId;
                rentalSubcategoryId = searchPageVars.categories[newVal][0].children[0].id;

                const objFeatures = await api.getObjFeatures(rentalCategoryId, rentalSubcategoryId, businessUnitId);
                objFeatureEnums = objFeatures.enums;
                objFeatureRanges = objFeatures.ranges;
                objFacets = objFeatures.facets;
                if (Object.keys(objFacets).length > 0) {
                    facetsUpdated = true;
                    setOpenFilters(true);
                }
            }
        } else {
            clearFilters();
            showLocation = true;
            subcat = 'All';
        }
        if (facetsUpdated) {
            setSearchPageVars({
                ...searchPageVars,
                currentLoc: businessUnitId || 'All',
                currentSubcat: subcat,
                showCategory,
                showLocation,
                objFeatureEnums,
                objFeatureRanges,
                objFacets
            });
        } else {
            setSearchPageVars({
                ...searchPageVars,
                currentLoc: businessUnitId || 'All',
                currentSubcat: subcat,
                showCategory,
                showLocation
            });
        }
        setSearchParams({ ...searchParams, businessUnitId, rentalCategoryId, rentalSubcategoryId });
        if (isMarkerClick) {
            setSearchNow(true);
        }
    }

    const onChangeLocation = (e) => {
        setIsDirty(true);
        onLocationChanged(e.value, false);
    }

    const onChangeCategory = async (e) => {
        setIsDirty(true);

        let newVal = e.value;

        let { businessUnitId } = searchParams;
        let rentalSubcategoryId = newVal;
        let rentalCategoryId = null;
        let showLocation = searchPageVars.showLocation;
        let location = searchPageVars.currentLoc;

        let objFacets = {};
        let objFeatureEnums = [];
        let objFeatureRanges = [];

        if (newVal) {
            rentalCategoryId = masterData.categoriesAndLocations.find(item => item.RentalSubcategory_Id === newVal).RentalCategory_Id;
            if (searchPageVars.locations[newVal].length === 1) {
                showLocation = false;
                businessUnitId = searchPageVars.locations[newVal][0].id;
            }
            const objFeatures = await api.getObjFeatures(rentalCategoryId, rentalSubcategoryId, businessUnitId);
            objFeatureEnums = objFeatures.enums;
            objFeatureRanges = objFeatures.ranges;
            objFacets = objFeatures.facets;
            if (Object.keys(objFacets).length > 0) {
                setOpenFilters(true);
            }
        } else {
            clearFilters();
            location = 'All';
        }
        setSearchPageVars({
            ...searchPageVars,
            currentLoc: location,
            currentSubcat: newVal || 'All',
            showLocation,
            objFeatureEnums,
            objFeatureRanges,
            objFacets
        });
        setSearchParams({ ...searchParams, businessUnitId, rentalCategoryId, rentalSubcategoryId });
    }

    const onChangeStartDate = (date) => {
        if (date < new Date()) {
            //return;
        }
        setIsDirty(true);
        var updateEnd = false;
        if (date > searchParams.endDate) {
            updateEnd = true;
        }
        if (updateEnd) {
            setSearchParams({ ...searchParams, startDate: date, endDate: new Date(date.getTime()) });
        } else {
            setSearchParams({ ...searchParams, startDate: date });
        }
    }

    const onChangeEndDate = (date) => {
        var sDate = new Date(searchParams.startDate.getTime());
        sDate.setHours(0, 0, 0, 0);
        if (date < new Date() || date < sDate) {
            return;
        }
        setIsDirty(true);
        setSearchParams({ ...searchParams, endDate: date });
    }

    const hasFilters = () => {
        return (Object.keys(optionsSelected).length || Object.keys(rangeFilters).length);
    }

    const clearFilters = () => {
        setOptionsSelected({});
        setRangeFilters({});
        setOpenSlider('');
    }

    const onClickSearch = async () => {
        if (props.page === 'Home') {
            history.push("/search");
        } else {
            setShowLoader(true);
            let results;
            if (hasFilters()) {
                results = await api.searchObjectsWithFilters(searchParams, 1, { optionsSelected, rangeFilters });
            } else {
                results = await api.searchObjects(searchParams, 1);
            }
            props.onGetSearchResults(results);
            setShowLoader(false);
            setIsDirty(false);
        }
    }

    const getFeatureOptionsLocalized = (feature) => {
        if (feature.DataType_Name === 'Boolean' && feature.featureOptions) {
            var fOption = feature.featureOptions[0];
            fOption.label = t(fOption.label);
        }
        return feature.featureOptions;
    }

    useEffect(() => {
        if (markerVars.isClicked) {
            onLocationChanged(markerVars.locationId, true);
        }
    }, [markerVars])

    return (
        <section className={"searchbar-container " + getSearchContainerClass()}>
            <div className="wrapper">
                <div className="row">
                    <div className="column-12">
                        <div className="search-container">
                            {/* Location Begin */}
                            {
                                searchPageVars.showLocation &&
                                <div className="search-content" onClick={() => !cartCount ? refLocation.current.open() : null}>
                                    <div className="label small">{t("location")}</div>
                                    <Selectivity.React
                                        showDropdown={false}
                                        ref={refLocation}
                                        showSearchInputInDropdown={true}
                                        allowClear={true}
                                        closeOnSelect={true}
                                        multiple={false}
                                        readOnly={cartCount > 0}
                                        items={searchPageVars.locations[searchPageVars.currentSubcat] || []}
                                        placeholder='All'
                                        className="sr-wrapper"
                                        value={searchParams.businessUnitId}
                                        defaultValue={searchParams.businessUnitId}
                                        onChange={onChangeLocation}
                                        dropdownCssClass='ddSelect'
                                    />
                                </div>
                            }
                            {/* Location End */}

                            {/* Category Begin */}
                            {
                                searchPageVars.showCategory &&
                                <div className="search-content" onClick={() => !cartCount ? refCategory.current.open() : null}>
                                    <div className="label small">{t("category")}</div>
                                    <Selectivity.React
                                        showDropdown={false}
                                        ref={refCategory}
                                        showSearchInputInDropdown={true}
                                        allowClear={true}
                                        closeOnSelect={true}
                                        multiple={false}
                                        readOnly={cartCount > 0}
                                        items={searchPageVars.categories[searchPageVars.currentLoc] || []}
                                        placeholder='All'
                                        className="sr-wrapper"
                                        value={searchParams.rentalSubcategoryId}
                                        defaultValue={searchParams.rentalSubcategoryId}
                                        onChange={onChangeCategory}
                                        dropdownCssClass='ddSelect'
                                    />
                                </div>
                            }
                            {/* Category End */}

                            {/* StartDate/Time Begin */}
                            {
                                <div className={`search-content ${cartCount && isSameTimePeriod ? " dormant" : ""}`}>
                                    <DatePicker
                                        selected={searchParams.startDate}
                                        onChange={date => onChangeStartDate(date)}
                                        customInput={<CustomInputStart />}
                                        minDate={new Date()}
                                        maxDate={addDays(new Date(), maxAhead)}
                                        showTimeSelect={masterData.organization.showTime}
                                        timeIntervals={masterData.organization.showTime && masterData.organization.showMinutes ? 15 : 60}
                                        timeCaption="Time"
                                        readOnly={cartCount && isSameTimePeriod}
                                        popperClassName={masterData.organization.showTime ? 'datetime' : 'dateonly'}
                                        popperPlacement='top'
                                        dateFormat={masterData.organization.showTime ? "dd-MMM-yyyy HH:mm" : "dd-MMM-yyyy"}
                                    />
                                </div>
                            }
                            {/* StartDate/Time End */}

                            {/* EndDate/Time Begin */}
                            {
                                <div className={`search-content ${cartCount && isSameTimePeriod ? " dormant" : ""}`}>
                                    <DatePicker
                                        selected={searchParams.endDate}
                                        onChange={date => onChangeEndDate(date)}
                                        customInput={<CustomInputEnd />}
                                        minDate={new Date()}
                                        maxDate={addDays(new Date(), maxAhead)}
                                        showTimeSelect={masterData.organization.showTime}
                                        timeIntervals={masterData.organization.showTime && masterData.organization.showMinutes ? 15 : 60}
                                        timeCaption="Time"
                                        readOnly={cartCount && isSameTimePeriod}
                                        popperClassName={masterData.organization.showTime ? 'datetime' : 'dateonly'}
                                        popperPlacement='top'
                                        dateFormat={masterData.organization.showTime ? "dd-MMM-yyyy HH:mm" : "dd-MMM-yyyy"}
                                    />
                                </div>
                            }
                            {/* EndDate/Time End */}

                            <a id="btn-search" className={`search-btn ${isDirty ? 'dirty' : 'pristine'}`} onClick={onClickSearch} >
                                {t("search")} <i className="fa fa-search" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>
                {
                    props.page !== 'Home' && Object.keys(searchPageVars.objFacets).length > 0 &&
                    <div className={`filters-container-wrapper ${openFilters ? ' open' : ' closed'}`}>
                        <div className="feature-filters-dropdown" >
                            {openFilters && <div className='filters-container'>
                                <div className='row'>
                                    {searchPageVars.objFeatureEnums.length > 0 && searchPageVars.objFeatureEnums.map(feature => {
                                        return (<div className='column-3 feature-filter-enum'>
                                            {/* <div className='label' title={feature.refRentalParameterId}>{feature.RentalParameter_Name}</div> */}
                                            <ReactSelect
                                                options={getFeatureOptionsLocalized(feature)}
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={true}
                                                components={{
                                                    Option, ValueContainer, Placeholder, DropdownIndicator
                                                }}
                                                placeholder={feature.RentalParameter_Name}
                                                onInputChange={onInputChange}
                                                isClearable
                                                onChange={selected => onChangeMultiSelect(feature.refRentalParameterId, selected)}
                                                allowSelectAll={true}
                                                value={optionsSelected[feature.refRentalParameterId]}
                                            />
                                        </div>)
                                    })}
                                    {searchPageVars.objFeatureRanges.length > 0 && searchPageVars.objFeatureRanges.map((feature, index) => {
                                        return <RangeInputs feature={feature} />
                                    })}
                                </div>
                            </div>}
                        </div>
                        <div className='buttons-container'>
                            <a className="features-dd small" onClick={() => setOpenFilters(!openFilters)}>
                                {t("filters")} <i className="fa fa-caret-down" aria-hidden="true"></i>
                            </a>
                            <a className={`search-btn ${isDirty ? 'dirty' : 'pristine'}`} onClick={onClickSearch} >
                                {t("applyFilters")} <i className="fa fa-search" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                }
            </div>
        </section>
    );
}

export default SearchBar;